import FluffySlider from '@gotamedia/fluffy/Slider';
import { themeHelpers } from '@gotamedia/fluffy/theme';
import styled, { css } from 'styled-components';
import type { StyledMemoriaProps } from './types';

const CardWrapper = styled.div<StyledMemoriaProps>`
    display: flex;
    flex-direction: column;
    height: ${({ legacy }) => legacy ? 270 : 229}px;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "height: 347px;"}`)};
    min-width: 160px;
    box-shadow: 0px 2px 4px rgba(46, 42, 37, 0.12);
    background: #fff;
    position: relative;
    align-items: center;
    cursor: pointer;
    ${(props) => props.width === undefined ? undefined : css`
        width: ${props.width}px;
        margin-right: 10px;
    `}
`

const Slider = styled(FluffySlider)<{width: number, legacy?: boolean}>`
    height: ${({ legacy }) => legacy ? 300 : 256}px;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "height: 376px;"}`)};
    width: ${({ width }) => `${width}px`};
    margin: auto;
    ${themeHelpers.isSmallDevice(css`
        width: 100vw;
    `)};
`


const CardContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const SliderStiles = styled(Slider.Slides)`
    width: auto;
`

const SliderContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`

const ImageContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    margin-top: 0px;
    justify-content: center;
`

const CardImage = styled.img<StyledMemoriaProps>`
    max-width: 150px;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "max-width: 198px;"}`)};
    max-height: 270px;
    aspect-ratio: 2/1;
    object-fit: contain;
    padding-left: 5px;
    padding-right: 5px;
    padding-top:5px;
    object-position: top;
`

export {
    CardContainer, CardImage, CardWrapper, ImageContainer, Slider, SliderContainer, SliderStiles
};

